import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio169: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAspectRatio169"><Path d="M1.75 8.75C1.75 7.09315 3.09315 5.75 4.75 5.75H19.25C20.9069 5.75 22.25 7.09315 22.25 8.75V15.25C22.25 16.9069 20.9069 18.25 19.25 18.25H4.75C3.09315 18.25 1.75 16.9069 1.75 15.25V8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconAspectRatio169;
